var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeItalic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80791 13.1328L11.5393 5.01143C11.6777 4.34205 11.816 4.21268 13.0547 4.10355L13.1784 3.51855H8.93041L8.80666 4.10355C9.99916 4.21155 10.0757 4.34205 9.93729 5.01143L8.20929 13.1328C8.07091 13.8022 7.93254 13.9316 6.69504 14.0396L6.57129 14.6246H10.817L10.9408 14.0396C9.74829 13.9327 9.67066 13.8022 9.80904 13.1328H9.80791Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeItalic);
export default __webpack_public_path__ + "static/media/type-italic.6435135e0d8be8f4672c17ee015baabc.svg";
export { ForwardRef as ReactComponent };